module.exports = __webpack_public_path__ + "img/Acevaluator.55ab27a0.svg";